module.exports = __webpack_public_path__ + "img/ept.e1ababf7.png";